import React, { useEffect } from 'react'
import './TopQuestionsPage.scss'
import { TopQuestionsFilterPopover } from 'tabs/topQuestions/components/top_questins_filter/TopQuestionsFilterPopover'
import { fetchCurrentClusteringStatus } from 'tabs/topQuestions/lib/top_questions_config/clusteringConfigurationApi'
import { useDispatch, useSelector } from 'react-redux'
import { selectEndDateFilter, selectStartDateFilter } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusSelectors'
import { selectActiveBotId } from 'tabs/home/reducers/selectors'
import { selectClusteringExecutionId, selectFetchClusteringStatus } from 'tabs/topQuestions/lib/top_questions_config/clusteringConfigurationSelectors'
import { RequestStatus } from 'tabs/topQuestions/types/GenericTypes'
import { TopQuestionsPageContent } from 'tabs/topQuestions/components/top_questions_content/TopQuestionsPageContent'
import { dateObjectTimestampSeconds, dateObjectToDate } from 'tabs/topQuestions/utils/DateUtils'
import { clearSelectedExecutionId } from 'tabs/topQuestions/lib/top_questions_config/clusteringConfigurationActions'
import Button from '@mui/material/Button'
import { sendStartClusteringChartData } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusApi'

export const TopQuestionsPage: React.FC = () => {

  const dispatch = useDispatch()

  const selectedStartDate = useSelector(selectStartDateFilter)
  const selectedEndDate = useSelector(selectEndDateFilter)
  const activeBotId = useSelector(selectActiveBotId)
  const clusteringStatusRequest = useSelector(selectFetchClusteringStatus)
  const clusteringExecutionId = useSelector(selectClusteringExecutionId)

  const startTimestamp = dateObjectToDate(selectedStartDate).getTime() / 1000
  const endTimestamp = dateObjectToDate(selectedEndDate).getTime() / 1000

  useEffect(() => {
    if (startTimestamp != undefined && endTimestamp != undefined && activeBotId != undefined) {
      dispatch(clearSelectedExecutionId())
      dispatch(fetchCurrentClusteringStatus(activeBotId, startTimestamp, endTimestamp))
    }
  }, [startTimestamp, endTimestamp])

  const sendClusteringRequest = () => {
    const mingTimestamp = dateObjectTimestampSeconds(selectedStartDate)
    const maxTimestamp = dateObjectTimestampSeconds(selectedEndDate)
    dispatch(sendStartClusteringChartData(activeBotId, mingTimestamp, maxTimestamp))
  }

  return <div className={'topQuestionsPageWrapper'}>
    <div className={'topQuestionsPageHeaderWrapper'}>
      <div className={'topQuestionsTitleWrapper'}>
        <div className={'topQuestionsTitle'}>
          <h3>Top Questions</h3>
          <small>See questions most asked by users.</small>
        </div>
        <TopQuestionsFilterPopover />
      </div>
      <Button variant="outlined" onClick={() => sendClusteringRequest()}>
        Retry training
      </Button>
      {/*<ClusteringControls />*/}
    </div>
    <div className={'contentWrapper'}>
      {clusteringStatusRequest.status === RequestStatus.RESOLVED &&
        <TopQuestionsPageContent botId={activeBotId} clusteringExecutionId={clusteringExecutionId} />}
    </div>
  </div>
}
